import { render, staticRenderFns } from "./DocumentViewTool.vue?vue&type=template&id=6061ab3e&scoped=true&"
import script from "./DocumentViewTool.vue?vue&type=script&lang=ts&"
export * from "./DocumentViewTool.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentViewTool.vue?vue&type=style&index=0&id=6061ab3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6061ab3e",
  null
  
)

export default component.exports